import {AttributeDescriptor, BaseModel, BaseModelDescriptor} from "./BaseModel";
import {ValidationTypes} from "../core/Validator";
import {DepartmentRole, Role} from "./Role";
import {Upload} from "./Upload";
import {Position} from "./Position";

export const EMPTY_PASSWORD = ''

export class User extends BaseModel {
	id: string
	email: string
	firstName: string
	lastName: string
	password: string
	roleId: string
	isAdmin: boolean
	role: Role
	uploads: Upload[]
	positionId: string
	roles: DepartmentRole[]
}

export class UserDescriptor extends BaseModelDescriptor{
	static id: AttributeDescriptor = {validation: []}
	static email: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED, ValidationTypes.EMAIL]}
	static firstName: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static lastName: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static password: AttributeDescriptor = {validation: []}
	static roleId: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static positionId: AttributeDescriptor = {validation: []}
}



